import { DefaultService } from '@/services/DefaultService';

export default class TipoPedidoService extends DefaultService {
	constructor(http, router, env) {
		super(http, router, env);
	}

	updateSituacao(tipopedido) {
    return this._http.post(`${this._env}/vendas/tipopedido/updatesituacao`, tipopedido, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }

	findAll(column, order, page, limit, situacao, ...params) {
		return this._http.get( encodeURI(`${this._env}/vendas/tipopedido.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

	findAllCombo(...params) {
		return this._http.get(encodeURI(`${this._env}/vendas/getcombo/tipopedido.json?param=${params}`), this._headers).then(res => {
      return res.body;
		}, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
		});
	}

	find(id) {
		return this._http.get(`${this._env}/vendas/tipopedido/${id}.json`, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
    });
	}

	save(form) {
		return this._http.post(`${this._env}/vendas/tipopedido`, form, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }

	findAllFiltroPedido(column = 'datahorainc', order = 'desc', page = 0, limit = 50, ...params) {
		return this._http.get(encodeURI(`${this._env}/vendas/tipopedido/all.json?page=${page}&limit=${limit}&column=${column}&order=${order}&param=${params}`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}
}